import { render, staticRenderFns } from "./activaitor.vue?vue&type=template&id=4b7d4528&scoped=true"
import script from "./activaitor.vue?vue&type=script&lang=js"
export * from "./activaitor.vue?vue&type=script&lang=js"
import style0 from "./activaitor.vue?vue&type=style&index=0&id=4b7d4528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7d4528",
  null
  
)

export default component.exports